import {Injectable} from '@angular/core';
import moment from 'moment';
import {ApiResponse} from 'amc-common-components';
import {CtsDistributionApiTableItem} from '@entities/cts-distribution/cts-distribution-api-interfaces';
import {CtsEditPeriodData, CtsTableDataWithPagination} from '@entities/cts-distribution/cts-distribution.interfaces';
import {ItemCommon} from '@entities/common/common.interface';
import {API_DAY_FORMAT} from '@shared/constants/formats.constants';

/**
 * This class is an injectable Angular service that provides a way to fetch data.
 */
@Injectable()
export class CtsDistributionApiMapper {
	/**
	 * Static method Map Table Data for mapped data from API response.
	 * @param {ApiResponse<CtsDistributionApiTableItem[]>} docs.
	 * @returns {CtsTableDataWithPagination} - the mapped data for API response.
	 */
	public static mapTableData({docs}: ApiResponse<CtsDistributionApiTableItem[]>): CtsTableDataWithPagination {
		return {
			data: docs,
			pagination: {
				pageNum: docs[0]?.PAGE_NUM ?? 1,
				totalPages: docs[0]?.TOTAL_PAGES ?? 1,
			},
		};
	}

	/**
	 * Static method Map Platform Filter for mapped data from API response.
	 * @param {ApiResponse<{PLATFORM: string}[]>} docs.
	 * @returns {ItemCommon[]} - the mapped data for API response.
	 */
	public static mapPlatformFilter({docs}: ApiResponse<{PLATFORM: string}[]>): ItemCommon[] {
		return docs.map(({PLATFORM}) => ({
			id: PLATFORM,
			name: PLATFORM,
		}));
	}

	/**
	 * Static method Map Period Filter for mapped data from API response.
	 * @param {ApiResponse<{{MIN_DATE: string; MAX_DATE: string}} docs.
	 * @returns {CtsEditPeriodData} - the mapped data for API response.
	 */
	public static mapPeriodFilter({docs}: ApiResponse<{MIN_DATE: string; MAX_DATE: string}[]>): CtsEditPeriodData {
		return {
			minDate: moment(docs[0].MIN_DATE, API_DAY_FORMAT),
			maxDate: moment(docs[0].MAX_DATE, API_DAY_FORMAT),
		};
	}

	/**
	 * Static method Map Program type Filter for mapped data from API response.
	 * @param {ApiResponse<any} docs.
	 * @returns {ItemCommon[]} - the mapped data for API response.
	 */
	public static mapProgramTypeFilter({docs}: ApiResponse<{CONTENT_TYPE: string}[]>): ItemCommon[] {
		return docs.map(({CONTENT_TYPE}) => ({
			id: CONTENT_TYPE,
			name: CONTENT_TYPE,
		}));
	}
}
